import { IProps } from '.'
import React, { FC, useState } from 'react'
import GlobeIcon from './images/globe-icon.svg'
import DownArrowIcon from './images/down-arrow.svg'
import useTranslate from '../../hooks/useTranslate'
import { Text } from '../Text'

export const LocalePicker: FC<IProps> = ({ locales, selected = '', id, onChange }) => {
  const [value, setValue] = useState<string>(selected)
  const { translate } = useTranslate()

  const onSelectChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    if (!event?.target?.value) return

    setValue(event.target.value)

    if (onChange) {
      onChange(event.target.value)
    }
  }

  const currentValue = locales.find((locale) => locale.code === value)?.name

  return (
    <div>
      <div className={'local-picker-wrapper'}>
        <Text brand="default" size="caption">
          <p>{translate(currentValue ?? '')}</p>
        </Text>
        {/* eslint-disable-next-line jsx-a11y/no-onchange*/}
        <select className="locale-picker" name={id} id={id} onChange={onSelectChange}>
          {locales.map((locale) => (
            <option key={locale.code} value={locale.code} selected={locale.code === value}>
              {translate(locale.name)}
            </option>
          ))}
        </select>
      </div>

      <style jsx>{`
        .local-picker-wrapper {
          position: relative;

          p {
            background-image: url(${GlobeIcon}), url(${DownArrowIcon});
            background-repeat: no-repeat, no-repeat;
            background-size: 14px, 16px;
            background-position: left center, right center;
            padding: 0 20px;
          }

          &:hover {
            p {
              opacity: 0.8;
            }
          }
        }

        .locale-picker {
          position: absolute;
          padding: 0;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          box-sizing: border-box;
          appearance: none;
          background-color: transparent;
          font-size: 0;
          background-repeat: no-repeat, no-repeat;
          background-size: 14px, 16px;
          transition: outline 0.25s;
          cursor: pointer;
          border: none;
          z-index: 1;

          option {
            font-size: 13px;
          }
        }

        .locale-picker:focus {
          outline: none;
        }
      `}</style>
    </div>
  )
}
